var _path, _g, _rect, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveAttachmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M57 114C88.4802 114 114 88.4802 114 57C114 25.5198 88.4802 0 57 0C25.5198 0 0 25.5198 0 57C0 88.4802 25.5198 114 57 114Z",
    fill: "#FDDFCA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2257_60422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.8135 91.3769C76.2475 91.3769 92.002 75.6225 92.002 56.1884C92.002 36.7544 76.2475 21 56.8135 21C37.3794 21 21.625 36.7544 21.625 56.1884C21.625 75.6225 37.3794 91.3769 56.8135 91.3769Z",
    fill: "#FFDFCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8135 91.3769C76.2475 91.3769 92.002 75.6225 92.002 56.1884C92.002 36.7544 76.2475 21 56.8135 21C37.3794 21 21.625 36.7544 21.625 56.1884C21.625 75.6225 37.3794 91.3769 56.8135 91.3769Z",
    fill: "#FFDFCA",
    stroke: "#FF6B00",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 82.3008C71.5255 82.3008 83.3008 70.5255 83.3008 56C83.3008 41.4745 71.5255 29.6992 57 29.6992C42.4745 29.6992 30.6992 41.4745 30.6992 56C30.6992 70.5255 42.4745 82.3008 57 82.3008Z",
    fill: "#FEF5EF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2257_60422",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 30,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 30,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2257_60422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9781 73C55.7517 73 53.0086 71.8727 50.7486 69.618C48.4889 67.3633 47.3591 64.6185 47.3591 61.3835V46.0305L38.6641 37.336L40.4541 35.546L77.6256 72.718L75.8361 74.5075L68.7861 67.4575C67.7741 69.1138 66.4101 70.4517 64.6941 71.471C62.9784 72.4903 61.0731 73 58.9781 73ZM49.8716 48.5435V61.3835C49.8649 63.9228 50.7482 66.0748 52.5216 67.8395C54.2952 69.6045 56.4474 70.487 58.9781 70.487C60.7311 70.487 62.3102 70.045 63.7156 69.161C65.1206 68.2767 66.2009 67.099 66.9566 65.628L63.2386 61.91C62.9666 62.816 62.4419 63.5802 61.6646 64.2025C60.8872 64.8248 59.9917 65.136 58.9781 65.136C57.6741 65.136 56.5589 64.6795 55.6326 63.7665C54.7066 62.8538 54.2436 61.739 54.2436 60.422V52.928L49.8716 48.5435ZM56.7566 55.441V60.422C56.7566 61.0297 56.9704 61.5483 57.3981 61.978C57.8257 62.408 58.3461 62.623 58.9591 62.623C59.5734 62.623 60.0889 62.4077 60.5056 61.977C60.9222 61.5463 61.1341 61.0348 61.1411 60.4425V59.813L56.7566 55.441ZM68.0256 58.186V42.864H70.5386V60.718L68.0256 58.186ZM61.1411 51.263V43.14C61.1341 41.5723 60.5862 40.2425 59.4976 39.1505C58.4086 38.0588 57.0761 37.513 55.5001 37.513C54.4051 37.513 53.4172 37.8005 52.5366 38.3755C51.6559 38.9508 50.9941 39.6975 50.5511 40.6155L48.6896 38.741C49.4229 37.6043 50.3787 36.6967 51.5571 36.018C52.7354 35.3393 54.0497 35 55.5001 35C57.7581 35 59.6816 35.7953 61.2706 37.386C62.8596 38.9767 63.6541 40.901 63.6541 43.159V53.795L61.1411 51.263ZM56.7566 42.864V46.859L54.2436 44.327V42.864H56.7566Z",
    fill: "#FF6B00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2257_60422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(21 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveAttachmentIcon);
export default __webpack_public_path__ + "static/media/remove_attachment_icon.a7e7a6e75afe2b5dff46f01e22d417aa.svg";
export { ForwardRef as ReactComponent };